import PublicLayout from '../shell/layouts/PublicLayout.jsx';
import { lazyWithRetry } from '../utils/lazyWithRetry.js';

const HomePage = lazyWithRetry(() => import('../pages/public/homepage/HomePage.jsx'));

const publicRoutes = [
    {
        path: '/',
        element: <PublicLayout />,
        children: [
            {
                path: 'home',
                element: <HomePage />,
            },
        ],
    },
];

export default publicRoutes;